var bowser = require('bowser')

// getGaClientId returns ID of the client in Google Analytics
// return empty string if GA is not installed
function getGaClientId () {
	var clientId = ''
	if (!hasGA()) return clientId

	var allTrackers = window.ga.getAll() || []
	allTrackers.forEach(function (tracker) {
		clientId = tracker.get('clientId')
	})

	return clientId
}

// hasGA tells if the website is using Google Analytics or not
const hasGA = () => !!(window.ga && window.ga.getAll)

// getGaTrackingIds returns all tracking ids in Google Analytics
// return empty array if GA is not installed
function getGaTrackingIds () {
	var trackingIds = []
	if (!hasGA()) return trackingIds

	const allTrackers = window.ga.getAll() || []
	allTrackers.forEach(function (tracker) {
		var trackingId = tracker.get('trackingId')
		if (trackingId) trackingIds.push(trackingId)
	})

	return trackingIds
}

function getDeviceInfo () {
	let device = {
		user_agent: window.navigator.userAgent,
		screen_resolution: window.screen.width + 'x' + window.screen.height,
		source_referrer: document.referrer,
		platform: window.navigator.platform,
		referrer: document.URL,
		type: bowser.mobile ? 'mobile' : 'desktop',
		language: navigator.language || navigator.userLanguage,
	}

	let ga_client_id = getGaClientId()
	if (ga_client_id) device.ga_client_id = ga_client_id

	let ga_tracking_ids = getGaTrackingIds()
	if (ga_tracking_ids.length > 0) device.ga_tracking_ids = ga_tracking_ids

	return device
}

function sendToFBPixel (category, action, label) {
	if (!window.fbq) return

	window.fbq('trackCustom', category, { action: action, label: label })
}

function sendToGA (category, action, label) {
	if (!hasGA()) return

	const allTrackers = window.ga.getAll() || []
	allTrackers.forEach(function (tracker) {
		const name = tracker.get('name')
		window.ga(name + '.send', 'event', category, action, label)
	})
}

function sendEventToThirdParty (category, action, label) {
	sendToGA(category, action, label)
	sendToFBPixel(category, action, label)
}

module.exports = {
	sendEventToThirdParty,
	getDeviceInfo,
}
